import styles from './list.module.scss';

export default function ContactList({
  items,
  hrefProtocol
}: {
  items: Array<{ value: string; label: string }>;
  hrefProtocol: 'mailto' | 'tel';
}): JSX.Element {
  return (
    <ul className={styles.list}>
      {items.map((item, index) => (
        <li
          key={index}
          className={styles.list_item}>
          <a
            href={`${hrefProtocol}:${item.value}`}
            className={styles.list_link}>
            {item.value}
          </a>
          <p className={styles.list_label}>{item.label}</p>
        </li>
      ))}
    </ul>
  );
}
